import React from 'react';
import { ContentParagraph } from '../../../../_lib/components/ContentParagraph';
import { useSonTranslation } from '../../../../translation/useSonTranslation';

/**
 * Special HelpText for PortalSettings.
 */
export function RestartKeycloakHelpText({ id }: { id: string }) {
  const { t } = useSonTranslation('phrases');
  return (
    <div className="restart-keycloak-help-text" id={id}>
      <ContentParagraph>{`${t('keycloakNeedsRestart')} ${t('pleaseContactPortalAdmin')}`}</ContentParagraph>
    </div>
  );
}
